import { Text } from "@clipboard-health/ui-components";
import { Box } from "@mui/material";
import type { UserMessage } from "@sendbird/chat/message";

interface UserCustomChatMessageProps {
  message: UserMessage;
  isByMe: boolean;
}

export function UserCustomChatMessage(props: UserCustomChatMessageProps) {
  const { message, isByMe } = props;
  const borderRadius = isByMe ? "24px 24px 4px 24px" : "4px 24px 24px 24px";

  return (
    <Box
      sx={{
        padding: 5,
        background: (theme) => (isByMe ? theme.palette.info.light : theme.palette.secondary.main),
        borderRadius,
      }}
    >
      <Text variant="body1" color="text.primary">
        {message.message}
      </Text>
    </Box>
  );
}
